import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  connect() {
    requestAnimationFrame(() => this.check())
  }

  check() {
    if (!this.hasContentTarget || !this.hasButtonTarget) return
    const c = this.contentTarget
    if (c.scrollHeight > c.clientHeight + 4) {
      this.buttonTarget.classList.remove("hidden")
    } else {
      this.buttonTarget.classList.add("hidden")
    }
  }

  toggle(event) {
    event.preventDefault()
    const expanded = this.contentTarget.classList.toggle("expandedContent")
    this.buttonTarget.textContent = expanded ? (window.MediFyrI18n?.t?.show_less || "Show Less") : (window.MediFyrI18n?.t?.read_more || "Read More")
  }
}
